import React from 'react';
const Footer = () => {
    return(
        <div className="Footer">
            <div className="Email">
                <p>martinortegayung@gmail.com</p>
            </div>
        </div>
    )   
}

export default Footer;